import StaffRow from './StaffRow';

export default StaffRow;
